import Decimal from "decimal.js"

export default class NumberUtils{
  static nullOrUndef(...vals: any[]){
    for(const val of vals){
      if(val===null || val===undefined || isNaN(val)){
        return true
      }
    }
    return false
  }
  static nullOrUndefAll(...vals: any[]){
    for(const val of vals){
      if(val!==null && val!==undefined && isNaN(val)){
        return false
      }
    }
    return true
  }
   static isNumber(value: string){
      const num = Number(value)
     if(num || num===0){
       return true
     }else{
       return false
     }
   }
  static format(value: number, maxDigits?: number, noComma?: boolean){
    if(maxDigits !==undefined){
        value = NumberUtils.floor(value, maxDigits)
    }
    if(noComma === undefined){
      noComma = false
    }
    if(noComma){
      return value.toString()
    }else{
      const zeroPad3Digits = maxDigits ? new Intl.NumberFormat('ja') : new Intl.NumberFormat('ja')
      return zeroPad3Digits.format(value)
    }
  }


  static round(number:number, scale?:number){
    if(scale!==undefined){
      const ju = 10 ** scale
      return Decimal.div(Math.round(Decimal.mul(number, ju).toNumber()), ju).toNumber()
    }else{
      return number
    }
  }

  static ceil(number:number, scale?:number){
    if(scale!==undefined){
      const ju = 10 ** scale
      return Decimal.div(Math.ceil(Decimal.mul(number, ju).toNumber()), ju).toNumber()
    }else{
      return number
    }
  }

  static floor(number:number, scale?:number){
    if(scale!==undefined){
      const ju = 10 ** scale
      return Decimal.div(Math.floor(Decimal.mul(number, ju).toNumber()), ju).toNumber()
    }else{
      return number
    }
  }

  static summary(rows: [], getFunction:(rowArg: object) => number){
    let ret = 0
    for(const row of rows){
      const value = getFunction(row)
      if(value){
        ret += value
      }
    }
    return ret
  }

  static sum(...rows: (number | null)[]){
    let ret = 0
    for(const value of rows){
      if(value){
        ret += value
      }
    }
    return ret
  }

  static sum2(rows: (number | null)[]){
    let ret = 0
    for(const value of rows){
      if(value){
        ret += value
      }
    }
    return ret
  }

  static summaryTajigen(rows: [][], getFunction:(rowArg: object) => number){
    let ret = 0
    for(const row of rows){
      ret += NumberUtils.summary(row, getFunction)
    }
    return ret
  }
}